import React, { useEffect, useRef, useState } from 'react';
import TextBox from 'devextreme-react/text-box';
import { RadioGroup, SelectBox, TextArea, FileUploader, NumberBox } from 'devextreme-react';
import { DocumentationRequestTypes, DocumentationRequestWithSubtypes } from '../../../../../Constantes/documentataionRequestTypes';
import CheckBox from 'devextreme-react/check-box';
import { baseRequest } from '../../../../../fetch/basicThunk';
import { QUERY_GET_ITVS_BY_POSTAL_CODE, QUERY_GET_PROVINCE_BY_POSTALCODE } from '../../../../../fetch/constantQueries';
import { useDispatch, useSelector } from 'react-redux';
import { openModal } from '../../../../../redux/modal/modalSlice';
import { selectDocumentationRequestTemplates, selectDocumentationRequestTemplatesLoading } from '../../../../../redux/documentationRequestTemplates/selectors';
import { getDocumentationRequestTemplates } from '../../../../../redux/documentationRequestTemplates/thunks';
import { deleteStrangeCharacters } from '../../../../../commonFunctions/commonFunctions';
import { getFactoryITVBond } from '../../../../../redux/factoryItvBond/thunks';
import { selectContract } from '../../../../../redux/contract/selectors';
import { selectITVBondInfo } from '../../../../../redux/factoryItvBond/selectors';
import { clearITVBondInfo } from '../../../../../redux/factoryItvBond/factoryITVBondSlice';
import { factoryActive } from '../../../../../Constantes/factoryActive';
import { getTaxonomyTemplates } from '../../../../../redux/factoryProcessTemplates/thunks';
import { selectTaxonomyTemplates } from '../../../../../redux/factoryProcessTemplates/selectors';
import { locale } from 'devextreme/localization';

function InputWrapper(props) {
  const { classes, label } = props;
  return (
    <div className="dx-field">
      <label className={classes.label}>{label}</label>
      <div style={{ width: '100%' }} className="dx-field-value">
        {props.children}
      </div>
    </div>
  );
}

function FinancingRequestForm(props) {
  locale('pt-BR');
  const { classes, onChange, dataForm, template, onChangeAttachments } = props;
  const [stations, setStations] = useState([]);
  const dispatch = useDispatch();
  //const types = useSelector(selectDocumentationRequestTemplates);
  const types = useSelector(selectTaxonomyTemplates);
  const typesLoading = useSelector(selectDocumentationRequestTemplatesLoading);
  const contract = useSelector(selectContract);
  const fileUploadRef = useRef();
  const itvBondInfo = useSelector(selectITVBondInfo);
  const zoneTypes = ['Madrid', 'Barcelona', 'Otros'];
  const originalVhTypes = ['Itv', 'Extranjero', 'Zona de seguridad'];
  const aafTypes = ['Si', 'Junta Extremadura'];
  const itvTypes = ['ITV', 'ITV SC (Galicia)'];
  const costExcemptTypes = ['Sí', 'No'];
  const producerBookSubtypes = [
    { name: 'No entregado', code: 'producer_book_not_given' },
    { name: 'Extraviado', code: 'producer_book_lost' },
    { name: 'MTR', code: 'producer_book_mtr' },
  ];
  const accidentRateSubtypes = [
    { name: 'Vh. vigente NO MTR', code: 'no_accident_rate_certificate' },
    { name: 'Vh. vigente MTR', code: 'no_accident_rate_certificate_mtr' },
    { name: 'Vh. baja', code: 'no_accident_rate_certificate_inactive' },
  ];
  const [mtrSubtypes, setMtrSubtypes] = useState([
    { name: 'No MTR', code: `${type}` },
    { name: 'MTR', code: `${type}_mtr` },
  ]);
  const [type, setType] = useState(dataForm?.templateCode);

  useEffect(() => {
    if (type != null && fileUploadRef) {
      fileUploadRef.current.value = '';
    }
  }, [type]);
  // useEffect(()=>{
  //     dispatch(getDocumentationRequestTemplates())
  // },[])

  useEffect(() => {
    dispatch(getTaxonomyTemplates({ query: '?templateCode=' + template?.code }));
  }, []);

  useEffect(() => {
    if (dataForm?.postalCode && (!stations || stations.length == 0)) {
      setProvince();
    }
  }, []);

  useEffect(() => {
    if (type && types.length > 0) {
      onChange('templateId', getTemplateIdFromCode(type));
      if (hasSubtype(type)) {
        if (!selectedSubtypeBelongsToType()) {
          onChange('subtype', '');
        }
        setMtrSubtypes([
          { name: 'No MTR', code: `${type}` },
          { name: 'MTR', code: `${type}_mtr` },
        ]);
      }
      if (type === DocumentationRequestTypes.ITV_BOND && factoryActive) {
        contract?.plate && dispatch(getFactoryITVBond({ query: `?plate=${contract.plate}` }));
      } else {
        dispatch(clearITVBondInfo());
      }
    }
  }, [type, types]);

  async function fetchProvinceFromPostalCode(postalCode) {
    let province;
    try {
      province = await baseRequest({ param: postalCode }, dispatch, QUERY_GET_PROVINCE_BY_POSTALCODE, 'GET');
    } catch (error) {
      province = null;
      onChange('province', null);
      setStations([]);
    }

    return province;
  }

  async function setProvince() {
    if (!dataForm?.postalCode || dataForm?.postalCode.length < 5) {
      onChange('province', null);
      onChange('stationId', null);
      return;
    }

    const province = await fetchProvinceFromPostalCode(dataForm?.postalCode);

    if (province) {
      const provinceHasNewValue = province.name !== dataForm?.province;
      if (provinceHasNewValue) {
        onChange('stationId', null);
      }
      onChange('province', province.name);
      fetchStations(dataForm?.postalCode);
    } else {
      onChange('stationId', null);
    }
  }

  function setPhoneNumber(e) {
    let nonDigitsRegExp = /\D/gm;
    const filteredNumber = e.value.replace(nonDigitsRegExp, '');
    onChange('phoneNumber', filteredNumber);
  }

  function setNotes(e) {
    const filteredText = deleteStrangeCharacters(e.value);
    onChange('notes', filteredText);
  }

  async function fetchStations(postalCode) {
    try {
      const stations = await baseRequest({ param: postalCode }, dispatch, QUERY_GET_ITVS_BY_POSTAL_CODE, 'GET');
      if (stations) {
        setStations(stations);
      }
    } catch (error) {
      dispatch(openModal({ type: 'error', message: 'No se han podido cargar las ITVs' }));
    }
  }

  function getTemplateIdFromCode(code) {
    // const { id } = types.find((type) => type.code === code);
    const template = types.find((type) => type.code === code);
    if (template == undefined || template.id == undefined) return -1;

    return template.id;
  }

  function hasSubtype(type) {
    const hasSubtype = DocumentationRequestWithSubtypes.some((templateWithSubtypes) => templateWithSubtypes === type);
    return hasSubtype;
  }

  function selectedSubtypeBelongsToType() {
    const subtypes = getSubtypes(type);
    return subtypes.some((subtype) => subtype.code === dataForm.subtype);
  }

  function getSubtypes(type) {
    switch (type) {
      case DocumentationRequestTypes.ORIGINAL:
        return mtrSubtypes;
      case DocumentationRequestTypes.PRODUCER_BOOK:
        return producerBookSubtypes;
      case DocumentationRequestTypes.NO_ACCIDENT_RATE_CERTIFICATE:
        return accidentRateSubtypes;
      case DocumentationRequestTypes.TELEMATIC_COPY:
        return mtrSubtypes;
      case DocumentationRequestTypes.INVOICE_DUPLICATE:
        return mtrSubtypes;
      case DocumentationRequestTypes.ORIGINAL_DUPLICATE:
        return mtrSubtypes;
      default:
        return [];
    }
  }

  function setItvBondQueryOnly(value) {
    if (value === true) {
      onChange('subtype', 'itv_bond_query_only');
      onChange('aaff', null);
    } else {
      if (dataForm.subtype === 'itv_bond_query_only') {
        onChange('subtype', null);
      }
    }
    onChange('queryOnly', value);
  }

  function setItvAAFF(value) {
    if (!dataForm.queryOnly) {
      if (value === 'Junta Extremadura') {
        onChange('subtype', 'itv_bond_aaff');
      } else {
        if (dataForm.subtype === 'itv_bond_aaff') {
          onChange('subtype', null);
        }
      }
    }
    onChange('aaff', value);
  }

  function setQuotationApproval(value) {
    if (value === 'Simulação aprovada') onChange('financeApproved', true);
    if (value === 'Simulação recusada') onChange('financeApproved', false);
  }

  const financePlans = [
    { text: 'Parcela Única', value: 'Parcela Única' },
    { text: 'Plano Balão', value: 'Plano Balão' },
    { text: 'Plano Linear', value: 'Plano Linear' },
  ];

  const firstNameLabel = { 'aria-label': 'First Name' };
  const lastNameLabel = { 'aria-label': 'Last Name' };
  const fileUploaderLabel = { 'aria-label': 'Select Photo' };

  return (
    <div className={classes.containers} id="documentation-request-form">
      <InputWrapper classes={classes} label={'Tipo'}>
        <SelectBox
          searchEnabled
          disabled={typesLoading === 'loading'}
          value={type}
          onValueChanged={(e) => {
            setType(e.value);
            onChange('templateCode', e.value);
          }}
          valueExpr={'code'}
          displayExpr="name"
          placeholder=""
          dataSource={types}
          height={25}
        ></SelectBox>
      </InputWrapper>

      {type != null && (
        <>
          {type !== 'finance_quotation_approval' && type !== 'finance_quotation_plan' && (
            <InputWrapper classes={classes} label={'E-mail'}>
              <TextBox
                mode="email"
                key={'bankEmail'}
                name="bankEmail"
                value={dataForm?.bankEmail}
                onValueChanged={(e) => onChange('bankEmail', e.value)}
                className={classes.controlers}
                height={25}
              ></TextBox>
            </InputWrapper>
          )}

          {type === 'finance_quotation_plan' && (
            <InputWrapper classes={classes} label={'Tipo de plano'}>
              {/* <TextBox key={'financePlan'} name="financePlan" value={dataForm?.financePlan} onValueChanged={(e) => onChange('financePlan', e.value)} className={classes.controlers} height={25}></TextBox> */}
              <SelectBox
                height={25}
                name="financePlan"
                noDataText="Carregando tipos"
                dataSource={financePlans}
                value={dataForm?.financePlan}
                displayExpr={'text'}
                valueExpr={'value'}
                onValueChanged={(e) => onChange('financePlan', e.value)}
                placeholder="Tipo"
              />
            </InputWrapper>
          )}
          {type === 'finance_quotation_approval' && (
            <InputWrapper classes={classes} label={'Status da Simulação'}>
              <RadioGroup
                items={['Simulação aprovada', 'Simulação recusada']}
                onValueChanged={(e) => setQuotationApproval(e.value)}
                value={dataForm?.financeApproved != null ? (dataForm?.financeApproved ? 'Simulação aprovada' : 'Simulação recusada') : null}
                layout="horizontal"
                height={25}
                style={{ marginTop: 0 }}
              />
            </InputWrapper>
          )}

          {(type === 'finance_credit_analisys_request' || type === 'finance_credit_revalidation_request') && (
            <div className={props.classes.input_grid} style={{ marginBottom: 10 }}>
              {type === 'finance_credit_revalidation_request' && (
                <InputWrapper classes={props.classes} label={'Nº Proposta'}>
                  <NumberBox
                    key={'Nº Proposta'}
                    min={props.min || 0}
                    showSpinButtons={true}
                    showClearButton={false}
                    disabled={props.disabled}
                    value={dataForm?.proposalNumber || 0}
                    onValueChanged={(e) => onChange('proposalNumber', e.value)}
                    height={25}
                  />
                </InputWrapper>
              )}

              <InputWrapper classes={props.classes} label={'Limite Giro Conta C.'}>
                <NumberBox
                  key={'Limite Giro Conta Corrente'}
                  format={{
                    type: 'currency',
                    precision: 2,
                    currency: 'BRL',
                  }}
                  min={props.min || 0}
                  showSpinButtons={true}
                  showClearButton={false}
                  disabled={props.disabled}
                  value={dataForm?.currentAccountLimit || 0}
                  onValueChanged={(e) => onChange('currentAccountLimit', e.value)}
                  height={25}
                />
              </InputWrapper>
              <InputWrapper classes={props.classes} label={'Limite Cheque Esp.'}>
                <NumberBox
                  key={'Limite de Cheque Especial'}
                  format={{
                    type: 'currency',
                    precision: 2,
                    currency: 'BRL',
                  }}
                  min={props.min || 0}
                  showSpinButtons={true}
                  showClearButton={false}
                  disabled={props.disabled}
                  value={dataForm?.specialCheckLimit || 0}
                  onValueChanged={(e) => onChange('specialCheckLimit', e.value)}
                  height={25}
                />
              </InputWrapper>
              <InputWrapper classes={props.classes} label={'Limite Cartão Corp.'}>
                <NumberBox
                  key={'Limite Cartão Corporativo'}
                  format={{
                    type: 'currency',
                    precision: 2,
                    currency: 'BRL',
                  }}
                  min={props.min || 0}
                  showSpinButtons={true}
                  showClearButton={false}
                  disabled={props.disabled}
                  value={dataForm?.corporateCardLimit || 0}
                  onValueChanged={(e) => onChange('corporateCardLimit', e.value)}
                  height={25}
                />
              </InputWrapper>
              <InputWrapper classes={props.classes} label={'Limite Giro Franq.'}>
                <NumberBox
                  key={'Limite Giro Franquias'}
                  format={{
                    type: 'currency',
                    precision: 2,
                    currency: 'BRL',
                  }}
                  min={props.min || 0}
                  showSpinButtons={true}
                  showClearButton={false}
                  disabled={props.disabled}
                  value={dataForm?.franchiseLimit || 0}
                  onValueChanged={(e) => onChange('franchiseLimit', e.value)}
                  height={25}
                />
              </InputWrapper>
              <InputWrapper classes={props.classes} label={'Limite Compra Veíc.'}>
                <NumberBox
                  key={'Limite Compra Veículo'}
                  format={{
                    type: 'currency',
                    precision: 2,
                    currency: 'BRL',
                  }}
                  min={props.min || 0}
                  showSpinButtons={true}
                  showClearButton={false}
                  disabled={props.disabled}
                  value={dataForm?.vehiclePurchaseLimit || 0}
                  onValueChanged={(e) => onChange('vehiclePurchaseLimit', e.value)}
                  height={25}
                />
              </InputWrapper>
            </div>
          )}

          {type === 'finance_credit_revalidation_request' && (
            <InputWrapper classes={props.classes} label={'Observações'}>
              <TextArea
                key={'observations'}
                name="observations"
                value={dataForm?.observations}
                onValueChanged={(e) => onChange('observations', e.value)}
                className={classes.controlers}
                height={60}
              ></TextArea>
            </InputWrapper>
          )}

          <InputWrapper classes={classes} label={'Notas'}>
            <TextArea key={'notes'} name="notes" value={dataForm?.notes} onValueChanged={(e) => setNotes(e)} className={classes.controlers} height={60}></TextArea>
          </InputWrapper>

          <InputWrapper classes={classes} label={'Anexos'}>
            <FileUploader
              style={{ backgroundColor: 'white' }}
              inputAttr={fileUploaderLabel}
              onValueChanged={(e) => onChangeAttachments([...e.value])}
              selectButtonText="Selecione os arquivos"
              labelText="ou Arraste aqui"
              uploadMode="useForm"
              multiple
              //allowedFileExtensions=[]
              //accept="image/*"
              invalidFileExtensionMessage="Extensão não permitida"
              maxFileSize={4000000}
              invalidMaxFileSizeMessage="Tamanho de arquivo inválido"
              readyToUploadMessage="Ready to upload"
              ref={fileUploadRef}
            />
            <div style={{ display: 'flex', flexDirection: 'column', color: 'white' }}>
              {/* <span>
            Extensões permitidas: <span style={{ fontWeight: "bold" }}>.jpg, .jpeg, .gif, .png</span>
          </span> */}
              <span>
                Tamanho máximo por arquivo: <span style={{ fontWeight: 'bold' }}>4 MB</span>
              </span>
            </div>
          </InputWrapper>
        </>
      )}
    </div>
  );
}

export { FinancingRequestForm };
